import React, { Component } from 'react';
import { FicheDossierClient } from '../Fiche/FicheDossierClient';

export class DossierClientType extends Component {

    render = () => <FicheDossierClient
        peutAjouterBlocDossierClient={true}
        peutModifierBlocDossierClient={true}
        type='Opération'
    />;

}